export enum Wall {
  Back = 'back',
  BackGable = 'back-gable',
  Front = 'front',
  FrontGable = 'front-gable',
  Left = 'left',
  Right = 'right',
  InnerFront = 'inner-front',
  InnerLeft = 'inner-left',
  InnerRight = 'inner-right',
}
